import comp from "./AttachmentItemV2";
export default comp;
